import React from 'react';
import './spinner.css';

export class Spinner extends React.Component {

    render() {
        return (
            <div className="spinner-overlay">
                <div className="spinner"></div>
            </div>
        );
      }
}

